import React from 'react';
import { enGB, enUS } from 'date-fns/locale';
// @mui
import { Stack, TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import DateAdapter from '@mui/lab/AdapterDateFns';

import useDateFilter from 'src/hooks/useDateFilter';
import { getBrowserLocale } from 'src/utils/getBrowserLocale';

interface Props {
  onUpdate?: () => void;
}

const RangeDatePicker: React.FC<Props> = ({ onUpdate }) => {
  const currentBrowserLocale = getBrowserLocale();
  const { handleChange, dateRange } = useDateFilter();
  const datePlaceholder = currentBrowserLocale === 'en-US' ? 'mm/dd/yyyy' : 'dd/mm/yyyy';

  const onUpdateData = () => {
    onUpdate && onUpdate();
  };

  const onKeyDown = (e: any) => {
    e.preventDefault();
  };

  return (
    <LocalizationProvider dateAdapter={DateAdapter} adapterLocale={currentBrowserLocale === 'en-US' ? enUS : enGB}>
    <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }} alignItems={'flex-end'} justifyContent={'flex-end'}>
      <DatePicker
        label="From"
        value={dateRange.from}
        minDate={new Date('01/01/2000 00:00')}
        onChange={(newValue) => {
          if(newValue && dateRange.to && newValue > dateRange.to) {
            handleChange(newValue, 'to');
          }
          handleChange(newValue, 'from');
          onUpdateData();
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{ maxWidth: 200 }}
            onKeyDown={onKeyDown}
            placeholder={datePlaceholder}
            size="small"
            id="transaction-date-from"
          />
        )}
      />
      <DatePicker
        label="To"
        value={dateRange.to}
        minDate={dateRange.from}
        onChange={(newValue) => {handleChange(newValue, 'to'); onUpdateData()}}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{ maxWidth: 200 }}
            onKeyDown={onKeyDown}
            placeholder={datePlaceholder}
            size="small"
            id="transaction-date-to"
          />
        )}
      />
      </Stack>
    </LocalizationProvider>
  );
};

export default RangeDatePicker;
